<template>
    <div class="lp_list">
      <div class="title"  v-if="isShowTitle">
        <slot name="title">搜索结果（  <span>{{total}}</span>条 ）</slot>
      </div>
      <div class="list" v-if="dataList.length>0">
        <div class="item" v-for="(item,index) in dataList" :key="index" @click="itemClick(item,index)">
          <div class="right">
            <div class="name">{{ item.title }}</div>
            <!-- //此页面获取全部数据,1资讯、3政策、2申报通知、5高新风采、4第三方服务、 -->
            <p><span v-if="parseInt(item.newsType)<6">#{{parkId==4?['','资讯','申报通知','政策解读','第三方服务','新城风采'][parseInt(item.newsType)]:['','资讯','申报通知','政策解读','第三方服务','高新风采'][parseInt(item.newsType)]}}</span></p>
            <div class="bottomAction">
              <small>发布时间：{{ item.createTime | translatDateToDayPointStr}}</small>
              <div class="more">
                <span>查看详情</span>
                <img src="../../assets/images/more.png" alt="more">
              </div>
            </div>
          </div>
        </div>
      </div>
      <lp-empty v-else></lp-empty>
    </div>
</template>

<script>
  export default {
    name: "lp-HomeSearchList",
    props:{
      total:{//总数
        type:Number,
        default:0
      },
      isShowTitle:{
        type:Boolean,
        default:true
      },
      //数据
      dataList:{
        type:Array,
        default:()=>[]
      }
    },
    data () {
      return{

      }
    },
    computed: {
        parkId(){
            return this.$store.state.parkId;
        }
    },
    methods: {
      //点击item
      itemClick(item,index){
        this.$emit('itemClick',item,index);
      }
    },
  }
</script>

<style scoped lang="less">
.lp_list{
 .title{
    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    color: #272727;
    width: 100%;
    padding: 22px 30px;
    box-sizing: border-box;
    letter-spacing: 0;
    background: #F5F4F2;
    border: 1px solid #ddd;
  }
  .list{
    width: 100%;
    height: auto;
    .item{
      width: 100%;
      padding:24px 30px;
      box-sizing: border-box;
      border-bottom: 1px solid #E5E5E5;
      display: flex;
      cursor: pointer;
      .right{
        flex: 1;
        display: flex;
        flex-direction: column;
        // 标题
        .name{
          font-family: MicrosoftYaHei-Bold;
          font-size: 16px;
          color: #333333;
          letter-spacing: 0;
          font-weight: bold;
        }
         .name:hover{
           color: @hoverDefaultColor;
        }
        //类型
        p{
            width: 100%;
            word-break: break-all;
            display: inline-block;
            margin-top: 10px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #333;
            letter-spacing: 0;
        }
        //底部
        .bottomAction{
          flex: 1;
          width: 100%;
          height: 20px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 20px;
          small{
            height: 20px;
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
          } 
          .more{
            width: 100px;
            height: 20px;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            span{
              word-break: break-all;
              display: inline-block;
              font-family: MicrosoftYaHei;
              font-size: 14px;
              color: #333;
              letter-spacing: 0;
            }
            img{
              width: 14px;
              height: 14px;
              margin-left: 6px;
            }
          }
           
        }
        
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/homesearchlist/index.vue